/* Bounded campaign focus reveal; no image, copy or layout changes. */
(() => {
  if (window.tidiloPlacement13Focus) return;
  window.tidiloPlacement13Focus = true;
  document.addEventListener('focusin', (event) => {
    const link = event.target.closest?.('[data-placement13] a');
    if (!link || !matchMedia('(max-width: 767px)').matches) return;
    requestAnimationFrame(() => {
      if (document.activeElement !== link) return;
      const rect = link.getBoundingClientRect();
      const clearance = 8;
      const delta = rect.bottom + clearance > innerHeight
        ? Math.ceil(rect.bottom + clearance - innerHeight)
        : rect.top < clearance ? Math.floor(rect.top - clearance) : 0;
      if (delta) window.scrollBy({ top: delta, behavior: 'instant' });
    });
  });
})();
